module.exports = __webpack_public_path__ + "media/company.7916487d.mp4";